// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1G7fX","title":"ClientInsurance_title__3egXl","itemText":"ClientInsurance_itemText__2kNNA"};